import { HtmlText } from '@/components/ats/activities/HTMLText';
import { KImage, KText } from '@/ui-library/components';
import { Link } from '@chakra-ui/react';

const renderDrilldownHeader = (title: string) =>
  function DrilldownHeader() {
    return (
      <KText size="sm-medium" color="secondary-900" textTransform="none">
        {title}
      </KText>
    );
  };

export const useFlowHealthDrilldownConfig = ({
  onSort: _onSort = () => {},
  currentSort: _currentSort = {},
  resetDrill: _resetDrill,
}) => {
  const columns = () => {
    return [
      {
        Header: renderDrilldownHeader('Candidates'),
        id: 'candidate_name',
        accessor: 'contact',
        minWdith: 120,
        sort: true,
        Cell: ({ row }) => {
          const contact = row?.original?.contact;
          const { first_name, last_name, image_url, id } = contact ?? {};

          return (
            <>
              {first_name || last_name ? (
                <Link
                  href={`/candidates/${id}`}
                  target="_blank"
                  w="100%"
                  display="flex"
                  alignItems="center"
                  gap="6px"
                >
                  <KImage
                    name={`${first_name} ${last_name}`}
                    src={image_url}
                    backgroundStyles={{ minWidth: '20px', minHeight: '20px' }}
                  />
                  <KText
                    maxW="100%"
                    enableTooltip={true}
                    isTruncated
                    size="sm-regular"
                    _hover={{
                      textDecoration: 'underline',
                      color: 'primary-500',
                      cursor: 'pointer',
                    }}
                    textTransform="capitalize"
                  >
                    {first_name || ''} {last_name || ''}
                  </KText>
                </Link>
              ) : (
                '-'
              )}
            </>
          );
        },
      },
      {
        Header: renderDrilldownHeader('Last activity'),
        accessor: 'activity',
        minWdith: 150,
        sort: true,
        Cell: ({ row }) => {
          return (
            <KText fontSize="14px" fontWeight="medium" textAlign="left">
              <HtmlText html={row.original?.activity?.event} />
            </KText>
          );
        },
      },
    ];
  };
  return {
    columns: columns(),
  };
};
